<template>
    <a-switch v-model="darkTheme" @change="toggleTheme" />
   <!-- <a-config-provider :theme="themeConfig">
      <a-switch v-model="darkTheme" @change="toggleTheme" />
    </a-config-provider>-->
  </template>
  
  <script>
  //import { ConfigProvider } from 'ant-design-vue';
  
  export default {
    components: {
    //  AConfigProvider: ConfigProvider,
    },
    data() {
      return {
        darkTheme: false,
      };
    },
    computed: {
      themeConfig() {
        return {
          algorithm: this.darkTheme ? 'dark' : 'default',
        };
      },
    },
    methods: {
      toggleTheme(checked) {
        this.darkTheme = checked;
      },
    },
  };
  </script>